import * as Fullstory from '@fullstory/browser';
import { isAnalyticsEnabled } from '../core/lib';
import { FullstoryCustomerData, SonarFullstoryWindow } from './@types';

declare const window: SonarFullstoryWindow;

export function initializeFullstory(data: FullstoryCustomerData): void {
	// eslint-disable-next-line camelcase
	const { fullstory_org_id } = window.sonar;

	// eslint-disable-next-line camelcase
	if (fullstory_org_id) {
		const { uid, ...rest } = data;
		const devMode = !isAnalyticsEnabled();

		Fullstory.init({
			devMode,
			// eslint-disable-next-line camelcase
			orgId: fullstory_org_id
		});

		Fullstory.identify(uid, rest);
	}
}
